/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeacherOption
 */
export interface TeacherOption {
    /**
     * 
     * @type {number}
     * @memberof TeacherOption
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TeacherOption
     */
    officeId: number;
    /**
     * 
     * @type {number}
     * @memberof TeacherOption
     */
    courseId: number;
    /**
     * 
     * @type {string}
     * @memberof TeacherOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TeacherOption
     */
    nameEn: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeacherOption
     */
    acceptResearchStudent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeacherOption
     */
    acceptMaster: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeacherOption
     */
    acceptDoctoral: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeacherOption
     */
    acceptExchange: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeacherOption
     */
    state: TeacherOptionStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum TeacherOptionStateEnum {
    Active = 'active',
    Hidden = 'hidden'
}

export function TeacherOptionFromJSON(json: any): TeacherOption {
    return TeacherOptionFromJSONTyped(json, false);
}

export function TeacherOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeacherOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'officeId': json['officeId'],
        'courseId': json['courseId'],
        'name': json['name'],
        'nameEn': json['nameEn'],
        'acceptResearchStudent': json['acceptResearchStudent'],
        'acceptMaster': json['acceptMaster'],
        'acceptDoctoral': json['acceptDoctoral'],
        'acceptExchange': json['acceptExchange'],
        'state': json['state'],
    };
}

export function TeacherOptionToJSON(value?: TeacherOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'officeId': value.officeId,
        'courseId': value.courseId,
        'name': value.name,
        'nameEn': value.nameEn,
        'acceptResearchStudent': value.acceptResearchStudent,
        'acceptMaster': value.acceptMaster,
        'acceptDoctoral': value.acceptDoctoral,
        'acceptExchange': value.acceptExchange,
        'state': value.state,
    };
}


